import { useQuery } from "react-query";
import { format } from "date-fns";

import { CustomerDocument } from "../../models";
import { RQ } from "../../globals/enums";
import { getAll } from "../../api/generic-api";

export const useCustomerDocumentsByDateRange = (
  customerId: string,
  startDate?: Date,
  endDate?: Date
) => {
  let params = new URLSearchParams();
  startDate && params.append("startDate", format(startDate, "yyyy-MM-dd"));
  endDate && params.append("endDate", format(endDate, "yyyy-MM-dd"));
  customerId && params.append("customerId", customerId);
  return useQuery<CustomerDocument[], Error>(
    [RQ.CUSTOMER_DOCUMENTS, customerId],
    async () =>
      await getAll(`documents/customer-documents/date-range?${params}`),
    {
      enabled: Boolean(customerId),
    }
  );
};
